import { render } from "./Pagination.vue?vue&type=template&id=d9227094"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=d9227094&lang=scss"

import exportComponent from "/opt/build/repo/sleeper-trader/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__